export default __webpack_public_path__ + "static/media/button-arrow.091b02e7.svg";